import { useEffect, useState } from 'react';
import { useApiQuery } from '../../hooks/useApiQuery';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { StoryList } from '../../types/commerce';
import StoryCard from './StoryCard';
import './Stories.css';

export default function StoriesPage() {
  const [offset, setOffset] = useState(0);
  const [pages, setPages] = useState<Record<number, StoryList>>({});
  const query = useApiQuery<StoryList>(`/commerce/stories?offset=${offset}&limit=12`);
  useDocumentTitle('Stories');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (query.data) {
      const page = query.data;
      setPages((previous) => ({ ...previous, [page.offset]: page }));
    }
  }, [query.data]);
  const loaded = Object.values(pages).sort((a, b) => a.offset - b.offset);
  const stories = Array.from(
    new Map(loaded.flatMap((page) => page.items).map((story) => [story.id, story])).values(),
  );
  const last = loaded[loaded.length - 1];
  return (
    <section className="stories-page page-container">
      <h1>Stories</h1>
      <div className="stories-grid">
        {stories.map((story) => (
          <StoryCard key={story.id} story={story} />
        ))}
      </div>
      {query.loading && <p role="status">Loading stories…</p>}
      {query.error && (
        <div role="alert">
          <p>Could not load stories.</p>
          <button onClick={query.reload}>Try again</button>
        </div>
      )}
      {!query.loading && !query.error && !stories.length && <p>Our stories are coming soon.</p>}
      {last?.has_more && !query.error && (
        <button disabled={query.loading} onClick={() => setOffset(last.offset + last.items.length)}>
          Load more stories
        </button>
      )}
    </section>
  );
}
